import React from "react";
import styles from "./Nav.module.css"
import Button from "../Button/Button";
import MediaQueryUtils from "../../utils/MediaQueryUtils";
import {useDispatch} from "react-redux";
import {setSearch} from "../../actions/IndexActions";
import {useHistory} from "react-router";
import Utils from "../../utils/Utils"
import ModaleAnnulla from "../modaleAnnulla/ModaleAnnulla";

function Nav(props) {

    const dispatch = useDispatch()
    const history = useHistory()
    const sessioneUtente = sessionStorage.getItem("sessioneUtente") ? JSON.parse(sessionStorage.getItem("sessioneUtente")) : {}
    let isPageWide = MediaQueryUtils('(min-width: 1200px)')
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const provincePerCodice = JSON.parse(sessionStorage.getItem("provincePerCodice"))
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))

    function myFunction() {
        let x = document.getElementById("myLinks");
        if (x.style.display === "block") {
            x.style.display = "none";
        } else {
            x.style.display = "block";
        }
    }


    const iconButton = (
        <div style={{marginRight: "10px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#0a5576"
                 className={"bi bi-search ".concat(styles.searchIcon)} viewBox="0 0 16 16">
                <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
        </div>
    )

    function onClickButtonSearch() {
        dispatch(setSearch(true))
    }

    return (
        <div className={"noPrint"}>
            {isPageWide ?
                <div className={styles.styleSecondFascia}>
                    <div className="row" style={{minHeight: "80px", width: "100%", margin: "0px"}}>
                            <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: window.location.pathname === "/login-callback" ? "none" : "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/home" || window.location.pathname === "/cercaAssistenteFamiliare" ? "#0e294b" : ""
                            }} onClick={()=> {
                                if (window.location.pathname === "/wizardRegistro") {
                                    document.getElementById("ButtonHome").click();
                                }else {
                                    window.location.href="/home"
                                }
                            }
                            }>
                                <label className={styles.labelMenuCustom}>Home</label>
                            <Button
                                id={"ButtonHome"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaHome"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/home"}}/>}
                                header={"Attenzione!"}
                            />
                            </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/doveSiamo" ? "#0e294b" : ""
                        }} onClick={()=> {
                            if (window.location.pathname === "/wizardRegistro") {
                            document.getElementById("ButtonDove").click();
                        }else {
                            window.location.href="/doveSiamo"
                        }
                        }}>
                                <label className={styles.labelMenuCustom}>Dove Siamo</label>
                            <Button
                                id={"ButtonDove"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaDove"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/doveSiamo"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/faq" ? "#0e294b" : ""
                        }} onClick={()=> {
                            if (window.location.pathname === "/wizardRegistro") {
                                document.getElementById("ButtonFaq").click();
                            }else {
                                window.location.href="/faq"
                            }
                        }}>
                                <label className={styles.labelMenuCustom}>FAQ</label>
                            <Button
                                id={"ButtonFaq"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaFaq"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/faq"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        {sessioneUtente && sessioneUtente.tipoUtente === "01" ?
                            <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/registro" || window.location.pathname === "/wizardRegistro" ? "#0e294b" : ""
                            }} onClick={()=> {
                                if (window.location.pathname === "/wizardRegistro") {
                                    document.getElementById("ButtonRegistro").click();
                                }else {
                                    window.location.href="/registro"
                                }
                            }}>
                                    <label className={styles.labelMenuCustom}>Registro</label>
                                <Button
                                    id={"ButtonRegistro"}
                                    style={{
                                        display:"none",
                                    }}
                                    dataTarget={"modalAnnullaRegistro"}
                                    dataToggle={"modal"}
                                    dataBackdrop={"static"}
                                    dataKeyboard={false}
                                    body={<ModaleAnnulla onClick={()=>{window.location.href = "/registro"}}/>}
                                    header={"Attenzione!"}
                                />
                            </div> :
                            sessioneUtente && sessioneUtente.tipoUtente === "02" ?
                                <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                    minWidth: "fit-content",
                                    justifyContent: "center",
                                    display: window.location.pathname === "/login-callback" || !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                    alignItems: "center",
                                    background: window.location.pathname === "/profilo" ? "#0e294b" : ""
                                }} onClick={() =>
                                    Utils.recuperoDatiSintesiCandidato(sessioneUtente.codiceFiscale, dispatch, history, false, "/profilo", comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)}>
                                        <label className={styles.labelMenuCustom}>Profilo</label>
                                </div> : <></>}
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/utenti" ? "#0e294b" : ""
                        }} onClick={()=> {
                            if (window.location.pathname === "/wizardRegistro") {
                                document.getElementById("ButtonUtenti").click();
                            }else {
                                window.location.href="/utenti"
                            }
                        }}>
                                <label className={styles.labelMenuCustom}>Utenti</label>
                            <Button
                                id={"ButtonUtenti"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaUtenti"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/utenti"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/sportelli" ? "#0e294b" : ""
                        }} onClick={()=> {
                            if (window.location.pathname === "/wizardRegistro") {
                                document.getElementById("ButtonSportelli").click();
                            }else {
                                window.location.href="/sportelli"
                            }
                        }}>
                                <label className={styles.labelMenuCustom}>Sportelli</label>
                            <Button
                                id={"ButtonSportelli"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaSportelli"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/sportelli"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente?.ruolo?.toUpperCase() !== "RAF-RDSS"? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/report" ? "#0e294b" : ""
                        }} onClick={()=> {
                            if (window.location.pathname === "/wizardRegistro") {
                                document.getElementById("ButtonReport").click();
                            }else {
                                window.location.href="/report"
                            }
                        }}>
                                <label className={styles.labelMenuCustom}>Report</label>
                            <Button
                                id={"ButtonReport"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaReport"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/report"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1"} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "none" : "flex",
                            alignItems: "center"
                        }}>
                            <div className={styles.verticaLine} style={{
                                display: window.location.pathname === "/utenti" ||
                                window.location.pathname === "/sportelli" ||
                                window.location.pathname === "/registro" ||
                                !sessioneUtente ||
                                sessioneUtente && sessioneUtente.tipoUtente === "03" ? "" : "none",
                            }}/>
                        </div>
                        <div className={"col-2"} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "none" : "flex",
                            alignItems: "center"
                        }}>
                            <div>
                                <Button
                                    id={"ricercaButton"}
                                    onClick={onClickButtonSearch}
                                    typeButton={"White"}
                                    disabled={false}
                                    text={window.location.pathname === "/registro" ? "Ricerca Assistente" : window.location.pathname === "/utenti" ? "Ricerca Utente" : window.location.pathname === "/sportelli" ? "Ricerca Sportello" : ""}
                                    icon={iconButton}
                                    style={{
                                        height: "60px", width: "300px",
                                        display: window.location.pathname === "/utenti" ||
                                        window.location.pathname === "/sportelli" ||
                                        window.location.pathname === "/registro" ||
                                        !sessioneUtente ||
                                        sessioneUtente && sessioneUtente.tipoUtente === "03"
                                        || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "" : "none"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className={styles.topnav}>
                    <nav className={"navbar navbar-dark ".concat(styles.styleSecondFascia)}>
                        <div className="container-fluid">
                            <button className="navbar-toggler" type="button" onClick={myFunction}>
                                <span className="navbar-toggler-icon"/>
                            </button>
                        </div>
                    </nav>
                    <div id="myLinks" style={{display: "none", backgroundColor: "#1B7EA9"}}>
                        <a style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/home" || window.location.pathname === "/cercaAssistenteFamiliare" ? "#0e294b" : ""
                        }} onClick={()=> {
                            if (window.location.pathname === "/wizardRegistro") {
                                document.getElementById("ButtonHome").click();
                            }else {
                                window.location.href="/home"
                            }
                        }}><label className={styles.labelMenuCustom}>Home</label>
                            <Button
                                id={"ButtonHome"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaHome"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/home"}}/>}
                                header={"Attenzione!"}
                            /></a>
                        <a style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/doveSiamo" ? "#0e294b" : ""
                        }}
                           onClick={()=> {
                               if (window.location.pathname === "/wizardRegistro") {
                                   document.getElementById("ButtonDove").click();
                               }else {
                                   window.location.href="/doveSiamo"
                               }
                           }}><label className={styles.labelMenuCustom}>Dove Siamo</label>
                            <Button
                                id={"ButtonDove"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaDove"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/doveSiamo"}}/>}
                                header={"Attenzione!"}
                            /></a>
                        <a style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/faq" ? "#0e294b" : ""
                        }}
                           onClick={()=> {
                               if (window.location.pathname === "/wizardRegistro") {
                                   document.getElementById("ButtonFaq").click();
                               }else {
                                   window.location.href="/faq"
                               }
                           }}><label className={styles.labelMenuCustom}>FAQ</label>
                            <Button
                                id={"ButtonFaq"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaFaq"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/faq"}}/>}
                                header={"Attenzione!"}
                            /></a>
                        {sessioneUtente && sessioneUtente.tipoUtente === "01" ?
                            <a style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/registro" || window.location.pathname === "/wizardRegistro" ? "#0e294b" : ""
                            }}
                               onClick={()=> {
                                   if (window.location.pathname === "/wizardRegistro") {
                                       document.getElementById("ButtonRegistro").click();
                                   }else {
                                       window.location.href="/registro"
                                   }
                               }}>
                                <label className={styles.labelMenuCustom}>Registro</label>
                                <Button
                                    id={"ButtonRegistro"}
                                    style={{
                                        display:"none",
                                    }}
                                    dataTarget={"modalAnnullaRegistro"}
                                    dataToggle={"modal"}
                                    dataBackdrop={"static"}
                                    dataKeyboard={false}
                                    body={<ModaleAnnulla onClick={()=>{window.location.href = "/registro"}}/>}
                                    header={"Attenzione!"}
                                />
                            </a> :
                            sessioneUtente && sessioneUtente.tipoUtente === "02" ?
                                <span style={{
                                    minWidth: "fit-content",
                                    justifyContent: "center",
                                    display: window.location.pathname === "/login-callback" || !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                    alignItems: "center",
                                    background: window.location.pathname === "/profilo" ? "#0e294b" : ""
                                }}
                                      onClick={() => Utils.recuperoDatiSintesiCandidato(sessioneUtente.codiceFiscale, dispatch, history, false, "/profilo", comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)}>
                                        <label className={styles.labelMenuCustom}>Profilo</label>
                                    </span> : <></>}
                        <a style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/utenti" ? "#0e294b" : ""
                        }}
                           onClick={()=> {
                               if (window.location.pathname === "/wizardRegistro") {
                                   document.getElementById("ButtonUtenti").click();
                               }else {
                                   window.location.href="/utenti"
                               }
                           }}><label className={styles.labelMenuCustom}>Utenti</label>
                            <Button
                                id={"ButtonUtenti"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaUtenti"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/utenti"}}/>}
                                header={"Attenzione!"}
                            /></a>
                        <a style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/sportelli" ? "#0e294b" : ""
                        }}
                           onClick={()=> {
                               if (window.location.pathname === "/wizardRegistro") {
                                   document.getElementById("ButtonSportelli").click();
                               }else {
                                   window.location.href="/sportelli"
                               }
                           }}><label className={styles.labelMenuCustom}>Sportelli</label>
                            <Button
                                id={"ButtonSportelli"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaSportelli"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/sportelli"}}/>}
                                header={"Attenzione!"}
                            /></a>
                        <a style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ||   sessioneUtente?.ruolo?.toUpperCase() !== "RAF-RDSS"? "none" : "flex",
                            alignItems: "center"
                        }}
                           onClick={()=> {
                               if (window.location.pathname === "/wizardRegistro") {
                                   document.getElementById("ButtonReport").click();
                               }else {
                                   window.location.href="/report"
                               }
                           }}>
                            <label className={styles.labelMenuCustom}>Report</label>
                            <Button
                                id={"ButtonReport"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaReport"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/report"}}/>}
                                header={"Attenzione!"}
                            />
                        </a>
                        <a style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "none" : "flex",
                            alignItems: "center"
                        }}>
                            <Button
                                id={"ricercaButton"}
                                style={{
                                    display: window.location.pathname === "/utenti" ||
                                    window.location.pathname === "/sportelli" ||
                                    window.location.pathname === "/registro" ||
                                    !sessioneUtente ||
                                    sessioneUtente && sessioneUtente.tipoUtente === "03"
                                    || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "" : "none",
                                    width: "300px",
                                    height: "50px"
                                }}
                                onClick={onClickButtonSearch}
                                typeButton={"White"}
                                disabled={false}
                                text={window.location.pathname === "/registro" ? "Ricerca Assistente" : window.location.pathname === "/utenti" ? "Ricerca Utente" : window.location.pathname === "/sportelli" ? "Ricerca Sportello" : ""}
                                icon={iconButton}
                            />
                        </a>
                    </div>
                </div>
            }
        </div>
    )
}

export default Nav


